import Marionette from "backbone.marionette";
import BNotify from "bootstrap-notify";
import S from "session/session.js";

export default function () {
    S.mApp.off("notify:success").on("notify:success", function (data) {
        $.notify({
            icon: 'glyphicon glyphicon-ok',
            message: data.message
        }, {
            type: 'success'
        });
    });

    S.mApp.off("notify:error").on("notify:error", function (data) {
        $.notify({
            icon: 'glyphicon glyphicon-warning-sign',
            message: data.message
        }, {
            type: 'danger'
        });
    });
}


//////////////////
// WEBPACK FOOTER
// ./app/views/notifications.js
// module id = 198
// module chunks = 0